export default __webpack_public_path__ + "59f670bf39768d46f47ad7a6fea13daf.png";